// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__E8oNj","primary":"style_primary__3jCpE","block":"style_block__20LkS","buttonLoader":"style_buttonLoader__3uhXI","spinner":"style_spinner__30Qaf"};